import { motion } from "framer-motion";
import { Banknote, GraduationCap, Radio } from "lucide-react";

const PRIZES = [
  {
    icon: Banknote,
    amount: "$500 Cash Account Credit",
    detail: "Deposited straight into your FXTM live trading account, with full withdrawal rights after 1 valid trade.",
    featured: true,
    testid: "prize-card-500",
  },
  {
    icon: Radio,
    amount: "FXTM VIP Daily Signals Access",
    detail: "Exclusive access to institutional-grade Forex signals for EUR/USD, GBP/USD and Gold (XAU/USD).",
    featured: false,
    testid: "prize-card-signals",
  },
  {
    icon: GraduationCap,
    amount: "1-on-1 Analyst Masterclass",
    detail: "A private 60-minute strategy session with senior FXTM Africa trading mentors.",
    featured: false,
    testid: "prize-card-masterclass",
  },
];

export default function Prizes() {
  return (
    <section data-testid="prizes-section" className="relative px-4 py-24 sm:px-6">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(255,0,0,0.07)_0%,rgba(10,13,20,0)_70%)]" />
      <div className="relative mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-3 text-xs font-mono font-bold uppercase tracking-[0.3em] text-red-500">The Haul</p>
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            What You Stand to Win
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3">
          {PRIZES.map((prize, i) => {
            const Icon = prize.icon;
            return (
              <motion.div
                key={prize.amount}
                data-testid={prize.testid}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.15 }}
                whileHover={{ y: -6, scale: 1.01 }}
                className={`rounded-2xl border p-8 ${
                  prize.featured
                    ? "border-red-500/70 bg-gradient-to-b from-[#FFF1F2] to-[#FAFAFA] shadow-[0_0_40px_rgba(255,0,0,0.2)]"
                    : "border-slate-200 bg-[#FFFFFF]"
                }`}
              >
                <span className={`mb-6 flex h-14 w-14 items-center justify-center rounded-2xl ${prize.featured ? "bg-red-500 text-white" : "bg-red-600/15 text-red-500"}`}>
                  <Icon className="h-7 w-7" />
                </span>
                <h3 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">{prize.amount}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-500">{prize.detail}</p>
                {prize.featured && (
                  <span className="mt-5 inline-block rounded-full bg-red-500/15 px-3 py-1 text-[10px] font-mono font-bold uppercase tracking-[0.2em] text-red-500">
                    Main Prize ×10 Winners
                  </span>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
